export { default as FullPageLoader } from "./FullPageLoader";
export { OverLayLoader } from "./styled";
